import * as classnames from "classnames";

import { Checkbox, Form, FormGroup, Msg } from "@shared/components";
import { ApplicantChallengeModel } from "@shared/models";
import { ChallengeTakenBy } from "@shared/services/enums";
import Message from "@shared/services/message";

export type CodingCheckListPanelPropsNew = {
  takenBy: ChallengeTakenBy;
  challenge: ApplicantChallengeModel;
  onChange: (formValid: boolean) => void;
};

const CHECK_ITEMS: Partial<
  Record<ChallengeTakenBy, { titleKey: string; linkKey?: string }[]>
> = {
  [`${ChallengeTakenBy.WebBrowser}`]: [
    {
      titleKey: "start-challenge-walkthrough.setup.browser.howtotake",
      linkKey: "editor.link.coding.web",
    },
    {
      titleKey: "start-challenge-walkthrough.setup.browser.howtoinstall",
      linkKey: "editor.link.coding.lib.install",
    },
  ],
  [`${ChallengeTakenBy.LocalMachine}`]: [
    {
      titleKey: "start-challenge-walkthrough.setup.local.cliinstalled",
      linkKey: "editor.link.coding.cli.install",
    },
    {
      titleKey: "start-challenge-walkthrough.setup.local.howtotake",
      linkKey: "editor.link.coding.cli",
    },
    {
      titleKey: "start-challenge-walkthrough.setup.local.haverun",
    },
  ],
};

export const CodingCheckListPanelNew = (
  props: CodingCheckListPanelPropsNew,
) => {
  const { takenBy } = props;

  const rootStyle = classnames("code-coding-checklist-panel-new"); // TTODO: Rename this class once isWebcamEnabled feature flag is removed

  const onFormChange = (
    formValid: boolean,
    formValues: {
      options0?: boolean;
      options1?: boolean;
      options2?: boolean;
    },
  ) => {
    const keys = Object.keys(formValues) as Array<keyof typeof formValues>;
    props.onChange(
      keys.filter((key) => formValues[key] === true).length ===
        CHECK_ITEMS[takenBy]?.length,
    );
  };

  return (
    <div className={rootStyle}>
      <Form
        onFormChange={onFormChange}
        initialValues={{}}
        validation={{}}
        clear={true}
        className="code-coding-checklist-panel__body"
      >
        <div className="code-c-walk-through__item__subtitle">
          <Msg
            id={
              takenBy === ChallengeTakenBy.LocalMachine
                ? "start-challenge.local.option.text"
                : "start-challenge.web.option.text"
            }
          />
        </div>
        {CHECK_ITEMS[takenBy]?.map((item, index) => (
          <FormGroup key={index} className="code-coding-checklist-panel__item">
            <Checkbox
              className="code-coding-checklist-panel__check"
              name={`options${index}`}
            >
              <div className="code-coding-checklist-panel__doc">
                <span className="code-coding-checklist-panel__doc-link">
                  {item.linkKey ? (
                    <Msg
                      id={item.titleKey}
                      to={Message.getMessageByKey(item.linkKey)}
                    />
                  ) : (
                    <Msg id={item.titleKey} />
                  )}
                </span>
              </div>
            </Checkbox>
          </FormGroup>
        ))}
      </Form>
    </div>
  );
};
